/**
 * Which of the main destinations a path belongs to, for the header's links and
 * the tab bar to show where you are.
 *
 * Used by: TabBar, Header.
 *
 * @module isDestinationActive
 */

/**
 * Whether a destination is the page being shown, or the one a sub-page belongs
 * to: /plants stays lit on a plant page and the archive, but not on
 * /plants/photos, which is its own destination.
 *
 * @param pathname - The current location's path.
 * @param to - The destination's path.
 * @returns True when the destination should show as current.
 */
export function isDestinationActive(pathname: string, to: string): boolean {
  if (to === '/plants') {
    return (pathname === '/plants' || pathname.startsWith('/plants/')) && !pathname.startsWith('/plants/photos');
  }
  return pathname === to || pathname.startsWith(`${to}/`);
}
